import {v4 as uuid} from 'uuid';

import type {AnalyticsData} from '~/foundation/Monorail/types';

import type {
  DefaultComponentAnalyticsContext,
  ShopLoginButtonProps,
} from './types';

export const ANALYTICS_CONTEXT_TO_FLOW_MAP: Record<
  DefaultComponentAnalyticsContext,
  string
> = {
  loginWithShop: 'default',
  loginWithShopSelfServe: 'default',
  loginWithShopClassicCustomerAccounts: 'classic_customer_accounts',
  loginWithShopPrequal: 'shop_pay_installments_prequal',
  loginWithShopPaymentRequest: 'payment_request',
  loginWithShopCheckoutExtension: 'default',
  loginWithShopCheckoutModal: 'checkout_modal',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  checkout_sheet: 'checkout_sheet',
  loginWithShopShopWeb: '',
};

export function getAnalyticsProps({
  action,
  ...props
}: ShopLoginButtonProps): AnalyticsData {
  if (action === 'follow') {
    return {};
  }

  const {
    analyticsContext = 'loginWithShop',
    analyticsTraceId = uuid(),
    checkoutToken,
    checkoutVersion,
    flowVersion,
    shopId,
  } = props;
  return {
    analyticsContext,
    analyticsTraceId,
    checkoutVersion,
    checkoutToken,
    flow: ANALYTICS_CONTEXT_TO_FLOW_MAP[analyticsContext],
    flowVersion,
    shopId,
  };
}
